import {UseMutationResult, useMutation} from '@tanstack/react-query';
import {getLocalStorage} from '@/Utils/CommonUtils';
import useChatRestClient from '@/Api/ChatRestClient';

interface ActionPayload {
  popup_id: number;
  cta_action: string;
  mobile_number: string;
}

export default function useCTActionApi(
  handleOnSuccess?: () => void,
): UseMutationResult<void, Error, ActionPayload> {
  const ChatRestClient = useChatRestClient();

  return useMutation<void, Error, ActionPayload>(
    async (payload: ActionPayload) => {
      const token = await getLocalStorage('access_token');
      const options: any = {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      // Just await the call, don’t return data
      await ChatRestClient.post(
        'tournament/v1/update_popup_action',
        JSON.stringify(payload),
        options,
      );
    },
    {
      onSuccess: () => {
        if (handleOnSuccess) handleOnSuccess();
      },
      onError: (error: Error) => {
        console.error('Failed to update popup action:', error);
      },
    },
  );
}
